{
  "actions.delete_document.initiator.draft": "You are about to delete the document from DeepSign.",
  "actions.delete_document.initiator.pending": "The document is still in a signature process. By deleting it, the document is withdrawn and the signature process is cancelled.",
  "actions.delete_document.signer.aborted_completed": "You are about to delete the document from DeepSign.",
  "actions.delete_document.signer.pending": "Documents that are in the signature process cannot be deleted.",
  "actions.delete_document.signer.to_sign": "Documents that are in the signature process cannot be deleted.",
  "actions.delete_n_documents": "You are about to delete the document from DeepSign. | You are about to delete {n} documents from DeepSign.",
  "actions.first": "First",
  "actions.generate_qrcode": "Generate QR Code",
  "actions.last": "Last",
  "actions.manage_subscription": "Manage subscription",
  "actions.new_qrcode": "Generate new QR code",
  "actions.open_on_different_device": "Open DeepID on a different device",
  "actions.or": "Or",
  "actions.search": "Search",
  "actions.summarize_content": "Summarize content",
  "actions.upload": "upload",
  "aggregated.seals_uploaded": "{count} of {total} files successfully uploaded",
  "aggregated.started": "{count} of {total} have been sent successfully.",
  "aggregated.uploaded": "{count} of {total} files successfully uploaded as Draft",
  "apps.deep_sign": "Digital Signatures",
  "apps.deepbox": "Document sharing platform",
  "apps.subtitle.deepbox": "Securely store and share documents",
  "apps.subtitle.deepsign": "Secure legally valid electronic signatures",
  "authorities.did": "DeepID",
  "authorities.did_can_sign": "You can now use DeepID to sign the document.",
  "authorities.did_description": "Free digital identification service from DeepCloud",
  "authorities.ras": "Mobile ID",
  "authorities.ras_can_sign": "You can now use MobileID to sign the document.",
  "authorities.ras_description": "Digital (chargeable) or physical (free of charge) identification service from Swisscom",
  "authorities.sign8_description": "TEST FEATURE: Sign8 verification service (only for testing purposes)",
  "authorities.sms_code": "SMS-Code",
  "authorities.sms_code_description": "Authentication with one-time code",
  "authorities.yapid": "YapealID",
  "banners.remove_last_signee_in_group_warning": "You are removing the last open signee of the current signing group. The next group will automatically get the invitations to sign.",
  "banners.remove_last_signee_warning": "You are removing the last pending signee. The signing process will end and get the status “Signed”.",
  "banners.replace_signature_action": "Replace existing",
  "banners.replace_signature_placed": "Signature already placed",
  "batch.begin_process": "Start Batch Signing",
  "batch.documents_signed.title": "All these documents were fully signed:",
  "batch.enforced_authority_service": "Enforced authority service",
  "batch.error.autograph_position_required": "Signature must be placed to signing this document.",
  "batch.error.autograph_position_required_pill": "Visual signature required",
  "batch.error.autograph_required": "You must define a visual signature to sign this document.",
  "batch.error.autograph_required_pill": "Visual signature required",
  "batch.error.batch.file.tooBig": "The files you are trying to sign are too big.",
  "batch.error.generic_error": "Something went wrong while batch signing, please try again later.",
  "batch.error.identification_stale": "After 5 years, you must re-register your documents so that they can be used again for digital signing of documents. Please open your DeepID app and renew your ID document (passport or identity card) that allows you to sign digitally.",
  "batch.error.identity_proofing_process": "Unfortunately, you have not registered a valid ID document in DeepID that authorises you to sign documents digitally. The documents you have registered can unfortunately not be used for digital signing. Please open your DeepID app and register a new ID document (passport or identity card) that authorises you to sign digitally.",
  "batch.error.internal_error": "Unfortunately, an internal error has occurred. Please try again",
  "batch.error.maximum_file_size": "The total size of all documents must not exceed 40 MB. Remove files to continue with the process.",
  "batch.error.maximum_files": "You have reached the maximum of files to batch sign (100), please unselect some to continue with the process.",
  "batch.error.not_required_level": "You don't meet the level of the authority level required to sign this documents.",
  "batch.error.sign.document.autograph.position.required": "A visual signature must be placed for the signing of at least one document. It is therefore not possible to sign this selection of documents.",
  "batch.error.sign.document.autograph.required": "The visual signature is mandatory for at least one document. Please store the visual signature in the _link_ and then restart the process.",
  "batch.error.sign.failed": "Something went wrong. Please try again later.",
  "batch.error.sign.identity.not-ready": "Unfortunately, your registered ID document has not been verified yet. Have a little patience and try again in a few minutes.",
  "batch.error.sign.user.cancel": "You have cancelled the signature. Please try again.",
  "batch.error.sign.user.otp.invalid": "The SMS code was entered incorrectly too many times. Signing has failed. Please try again.",
  "batch.error.sign.user.timeout": "Time expired. Please try to sign the document again.",
  "batch.error.specific_document_failed": "Something went wrong while trying to sign this document on the batch process.",
  "batch.error.specific_document_required_authority_service": "For this document only the ID Service {enforce_authority_service} can be used.",
  "batch.error.unsuitable_domicile": "Unfortunately, your domicile is not currently supported by DeepID. We will notify you as soon as we have everything prepared and support your country.",
  "batch.error.visual_verification": "Unfortunately, your registered ID document has not been verified yet. Have a little patience and try again in a few minutes.",
  "batch.id_service_placeholder": "Please select one ID service",
  "batch.info.authority_service_required": "At least one document requires a specific ID Service, which is why you must use the selected one.",
  "batch.info.over_fourteen_files": " It may take longer to process a large number of documents. Please wait until the process is complete.",
  "batch.info.unmatching_authority_service_required": "This selection enforces different ID services. It is not possible to sign this combination of documents. Please remove documents or make a different selection.",
  "batch.preparing_files": "Preparing signature request",
  "buttons.add": "Add",
  "buttons.add_approver": "Add approver",
  "buttons.add_file": "Add document",
  "buttons.add_message": "Add message",
  "buttons.add_new_user_to_seal": "Add new user to seal",
  "buttons.add_observer": "Add observer",
  "buttons.add_signatory": "Add signatory",
  "buttons.apply": "Apply",
  "buttons.approve": "Approve",
  "buttons.approve_all_documents": "Approve {number} documents",
  "buttons.approve_now": "Approve document",
  "buttons.attach": "Attach",
  "buttons.attach_files": "Attach files",
  "buttons.attachment_actions": "Attachment actions",
  "buttons.back": "Back",
  "buttons.back_to_deepbox": "Back to DeepBox",
  "buttons.back_to_deepportal": "Back to Portal",
  "buttons.back_to_deepsign": "Back to DeepSign",
  "buttons.batch_remove": "Remove",
  "buttons.cancel": "Cancel",
  "buttons.change": "Change",
  "buttons.clear": "Clear",
  "buttons.clear_search": "Clear search",
  "buttons.close": "Close",
  "buttons.close_and_refresh": "Close & refresh",
  "buttons.confirm": "Confirm",
  "buttons.continue": "Continue",
  "buttons.continue_to_approve": "Continue to approve",
  "buttons.continue_to_seal": "Continue to seal",
  "buttons.continue_to_sign": "Continue to sign",
  "buttons.continue_with_deep_id": "Continue with DeepID",
  "buttons.create_account": "Create account",
  "buttons.create_account_for_email": "Register with invited email",
  "buttons.dashboard": "Dashboard",
  "buttons.delete": "Delete",
  "buttons.delete_document": "Delete document",
  "buttons.document_actions": "Document actions",
  "buttons.document_status": "Document status",
  "buttons.done": "Done",
  "buttons.download": "Download",
  "buttons.download_all": "Download all",
  "buttons.download_all_attachments": "Download all attachments",
  "buttons.edit": "Edit",
  "buttons.edit_email": "Edit email",
  "buttons.edit_observers": "Edit observers",
  "buttons.edit_participants": "Edit participants",
  "buttons.edit_signature_mode": "Edit signature mode",
  "buttons.forward_signature": "Forward signature",
  "buttons.identify": "Identify",
  "buttons.language": "Language",
  "buttons.load_more": "Load more",
  "buttons.login": "Log in",
  "buttons.login_as": "Login with invited user",
  "buttons.logout": "Logout",
  "buttons.logout_and_login_invited_email": "Logout and Login with invited user",
  "buttons.logout_and_proceed": "Logout & proceed",
  "buttons.logout_and_request_link": "Logout and request new link by email",
  "buttons.logout_and_show_document": "Logout and show document",
  "buttons.manage_account": "Manage your account",
  "buttons.more": "More",
  "buttons.move_down": "Move down",
  "buttons.move_up": "Move up",
  "buttons.new": "New",
  "buttons.new_document": "New document",
  "buttons.open": "Open",
  "buttons.open_cockpit": "Open DeepSign Cockpit",
  "buttons.open_deepid": "Open DeepID App",
  "buttons.overview": "Overview",
  "buttons.place": "Place",
  "buttons.place_seal": "Place seal",
  "buttons.place_signatures": "Place signature | Place signatures",
  "buttons.preview": "Preview",
  "buttons.proceed": "Continue",
  "buttons.quorum_cancel": "Cancel",
  "buttons.register": "Register",
  "buttons.register_invited_email": "Create new account for invited email",
  "buttons.reject": "Reject",
  "buttons.reject_now": "Reject",
  "buttons.reject_signature": "Reject signature",
  "buttons.remove": "Remove",
  "buttons.remove_approver": "Remove approver",
  "buttons.remove_attachment": "Remove attachment",
  "buttons.remove_document": "Remove document",
  "buttons.remove_file": "Remove attachment",
  "buttons.remove_observer": "Remove observer",
  "buttons.remove_signatures": "Remove signatures",
  "buttons.remove_signee": "Remove signee",
  "buttons.resend_email": "Resend E-Mail",
  "buttons.retry": "Retry",
  "buttons.save": "Save",
  "buttons.save_and_proceed": "Save and proceed",
  "buttons.seal": "Seal",
  "buttons.seal_now": "Seal now",
  "buttons.see_more_details": "Show details",
  "buttons.send_invitation": "Send invitation",
  "buttons.send_invitations": "Send invitations",
  "buttons.send_reminder": "Send reminder",
  "buttons.send_support_request": "Send support request",
  "buttons.settings": "Settings",
  "buttons.show_approver_action": "Use approver",
  "buttons.show_comment": "Show comment",
  "buttons.show_document_details": "Show details",
  "buttons.show_expert_settings": "Show additional settings",
  "buttons.sign": "Sign",
  "buttons.sign_all_documents": "Sign all {number} documents",
  "buttons.sign_anyway": "Sign anyway",
  "buttons.sign_as_guest": "Sign as Guest",
  "buttons.sign_n_documents": "Sign {number} documents",
  "buttons.sign_now": "Sign now",
  "buttons.sign_up": "Sign up",
  "buttons.status": "Status",
  "buttons.summarize": "Summarize (DEV)",
  "buttons.to_deepsign": "To DeepSign",
  "buttons.to_document_seal": "Seal Document",
  "buttons.to_document_sign": "Sign Document",
  "buttons.update_email": "Update email",
  "buttons.upload": "Upload",
  "buttons.upload_more_files": "Upload more documents...",
  "buttons.validate_signatures": "Validate signatures",
  "buttons.validating": "Validating",
  "buttons.view": "View",
  "buttons.withdraw": "Withdraw",
  "buttons.withdraw_document": "Withdraw document",
  "buttons.withdraw_documents": "Withdraw documents",
  "buttons.withdraw_signature": "Withdraw signature",
  "buttons.write_message_to_requestor": "Write message to requestor",
  "captions.element": "Element | Elements",
  "captions.optional": "optional",
  "cards.no_valid_company": "Your account can currently only be used to sign documents. To start signature processes yourself, we need further information from you.",
  "cards.no_valid_company_2": "Please note that, if you start your own signature processes, costs can occur. You can find an overview of our prices on our _link_.",
  "cards.onboarding.account.no_account": "You don't have an account?",
  "cards.onboarding.account.subtitle": "Continue with {email}",
  "cards.onboarding.account.title": "Log in with DeepBox",
  "cards.onboarding.disclaimer": "This page is intended solely for the use of the intended recipient and may contain confidential and privileged information. Please notify the sender immediately by e-mail if you have received this link by mistake.",
  "cards.onboarding.features.aes_qes": "Sign AES and QES eDocuments",
  "cards.onboarding.features.ses": "Sign SES eDocuments",
  "cards.onboarding.features.store_cloud": "Keep documents in cloud",
  "cards.onboarding.features.store_handwritten": "Store handwritten signature",
  "cards.onboarding.guest.subtitle": "Sign without DeepBox account.",
  "cards.onboarding.guest.subtitle_without_sid": "Link will be send to your email.",
  "cards.onboarding.guest.title": "Sign as Guest",
  "certificates.ch": "Swiss law (ZertES)",
  "certificates.eu": "EU law (elDas)",
  "checkboxes.signature_agreement": "I agree to use {electronicRecords} and {signatureDiscloser}.",
  "columns.created": "Created",
  "columns.name": "Name",
  "columns.status": "Status",
  "components.cropping.crop": "Cropping",
  "components.cropping.remove_background": "Remove Background",
  "components.emailSuggestions.orgMembersTitle": "Organisation members",
  "components.emailSuggestions.recentlyUsedEmailsTitle": "Recently used Emails",
  "components.signaturePad.draw_upload_signature": "Draw, {highlight}, or Drag and drop your signature",
  "components.signaturePad.drop_image_here": "Drop your image here",
  "components.signaturePad.remove": "Remove",
  "components.signaturePad.signature": "Visual signature",
  "components.signaturePad.upload": "upload",
  "dialogs.document_dialog.subtitles.remove_approver": "If you remove this person as an approver, they will lose access to this document and will no longer be able to approve.",
  "dialogs.document_dialog.subtitles.remove_observer": "By removing the observer from the list they will loose access to this document.",
  "dialogs.document_dialog.subtitles.remove_signee": "By removing this person as signee, they will lose access to this document and can no longer sign.",
  "dialogs.document_dialog.titles.add_observer": "Add observer",
  "dialogs.document_dialog.titles.edit_email": "Edit email",
  "dialogs.document_dialog.titles.forward_document": "Assign signature",
  "dialogs.document_dialog.titles.invite_signee": "Add signee",
  "dialogs.document_dialog.titles.remove_approver": "Remove approver",
  "dialogs.document_dialog.titles.remove_observer": "Remove observer",
  "dialogs.document_dialog.titles.remove_signee": "Remove signee",
  "dialogs.identify_warning.alert_text": "Authentication with specified number not possible.",
  "dialogs.identify_warning.alert_text_mobile_id": "Authentication via MobileID failed.",
  "dialogs.identify_warning.alert_text_mobile_id_not_activated_hint_link": "activate Mobile ID",
  "dialogs.identify_warning.alert_text_mobile_id_not_activated_hint_prefix": "Number not enabled for Mobile ID. Alternatively, you can use DeepID or",
  "dialogs.identify_warning.alert_text_mobile_id_not_activated_hint_prefix_batch": "Number not enabled for Mobile ID. Alternatively, you can use DeepID or",
  "dialogs.identify_warning.check_phone_number": "Check phone number",
  "dialogs.identify_warning.deep_id_text": "Use DeepID to be able to sign digitally directly. The identification process is digital and free of charge.",
  "dialogs.identify_warning.hint": "We were not able to verify your identity, because for the {auth_service} authentication a Swiss phone number is required.",
  "dialogs.identify_warning.hint_mobile_id": "We could not authenticate you because no registered MobileID was found with the provided phone number.",
  "dialogs.identify_warning.overline": "Digital identification with DeepID",
  "dialogs.identify_warning.subtitle": "Do you want to continue with DeepID?",
  "dialogs.identify_warning.title": "Authentication",
  "dialogs.invalid_invitation_link.primary_action": "Login with invited user",
  "dialogs.invalid_invitation_link.secondary_action": "Create account for invited user",
  "dialogs.invalid_invitation_link.text": "To access this document, you must log in with your existing account or create a new account if you don’t already have one.",
  "dialogs.invalid_invitation_link.title": "Log in or create an account",
  "dialogs.new_link_request.btn.request_new_link": "Request new link",
  "dialogs.new_link_request.invitation_sent_hint": "A new link has been sent to {email}, please use this new link to access the document.",
  "dialogs.new_link_request.invitation_sent_text": "A new link has been sent to you. ",
  "dialogs.new_link_request.link_sent_to": "The link will be sent to {email}",
  "dialogs.new_link_request.text_auth_p1": "For your security we need to do an additional check. Request a new link to your email {email} to access the document.",
  "dialogs.new_link_request.text_auth_p2": "Should you be logged in with the correct account already, you can also open the document from the DeepSign Cockpit instead.",
  "dialogs.new_link_request.text_p1": "To access the document, we need to send you a new secure link. The link will be sent to {email}.",
  "dialogs.new_link_request.text_p2": "If you already have an account with this email, you can alternatively log in.",
  "dialogs.new_link_request.title": "Additional check necessary",
  "dialogs.save_signature.text": "Thanks to a DeepSign account, you can save your signature and therefore sign even more easily in the future.",
  "dialogs.save_signature.title": "Save signature",
  "dialogs.session_invalid.btn_login": "Login",
  "dialogs.session_invalid.loggedout.msg": "To continue, please log in to DeepSign again.",
  "dialogs.session_invalid.loggedout.title": "You have been logged out",
  "dialogs.session_invalid.session_expired.msg": "To continue, please log in to DeepSign again.",
  "dialogs.session_invalid.session_expired.title": "You have been logged out",
  "dialogs.summarize.loading_text": "Summary is being generated",
  "dialogs.summarize.n_words_items.long": "Long",
  "dialogs.summarize.n_words_items.middle": "Normal",
  "dialogs.summarize.n_words_items.short": "Short",
  "dialogs.summarize.size.hint": "Generate a summary with approximately {n} words.",
  "dialogs.summarize.size.label": "Length of text",
  "dialogs.summarize.title": "Summarize",
  "document_status.aborted": "Aborted",
  "document_status.all": "All",
  "document_status.approval_on_hold": "Approval on hold",
  "document_status.approved": "Approved",
  "document_status.canceled": "Canceled",
  "document_status.completed": "Completed",
  "document_status.declined": "Declined",
  "document_status.draft": "Draft",
  "document_status.modified": "Modified",
  "document_status.notified": "Notified",
  "document_status.on_hold": "Signee on hold",
  "document_status.pending": "Pending",
  "document_status.quorum_reached_no_action": "No action required: the quorum has been reached",
  "document_status.rejected": "Rejected",
  "document_status.sealed": "Sealed",
  "document_status.signed": "Signed",
  "document_status.to_approve": "To Approve",
  "document_status.to_seal": "To Seal",
  "document_status.to_sign": "To Sign",
  "document_status.undefined": "Undefined",
  "document_status.viewed": "Document viewed",
  "document_status.waiting_for_approval": "Waiting for approval",
  "document_status.waiting_for_signature": "Waiting for signature",
  "document_status.withdrawn": "Withdrawn",
  "errors.aggregated.avScan.virusFound": "{count} of {total} files is infected by a virus | {count} of {total} files are infected by a virus",
  "errors.aggregated.error.pdf.certified.noChangeAllowed": "{count} of {total} files are certified, no changes allowed.",
  "errors.aggregated.error.pdf.password.protected": "{count} of {total} files is protected | {count} of {total} files are protected",
  "errors.aggregated.error.pdf.read.failed": "{count} of {total} files could not be read | {count} of {total} files could not be read",
  "errors.aggregated.error.pdf.signatureFieldLock.noChangeAllowed": "{count} of {total} files are locked by a signature and can not longer be signed.",
  "errors.aggregated.error.pdf.unsupported.encryption": "{count} of {total} files cannot be uploaded because it contains an unsupported encryption.",
  "errors.aggregated.error.predefined.multiple.signature.fields": "{count} out of {total} documents contain multiple seal placeholders, which is currently not supported.",
  "errors.aggregated.error.start.approver.email.empty": "{count} out of {total} documents have undefined e-mails for approvers.",
  "errors.aggregated.error.start.observer.email.duplicate": "{count} out of {total} documents have duplicate observers.",
  "errors.aggregated.error.start.observer.email.empty": "{count} out of {total} documents have undefined e-mails for observers.",
  "errors.aggregated.error.start.signee.email.empty": "{count} out of {total} documents have undefined e-mails for signers.",
  "errors.aggregated.error.start.signees.empty": "{count} out of {total} documents have undefined signers.",
  "errors.aggregated.error.start.status.draft.required": "{count} out of {total} documents are not in the correct status.",
  "errors.alpha_dash": "{name} field may contain alphabetic characters, numbers, dashes or underscores",
  "errors.alpha_num": "{name} field may only contain alpha-numeric characters",
  "errors.api.accounting.has_no_payment_method_member_admin": "Please contact your administrator and register a payment method to continue.",
  "errors.api.accounting.has_no_payment_method_member_admin_document_view": "To use advanced and qualified signatures, you must register a payment method.",
  "errors.api.accounting.has_no_payment_method_owner": "Please enter a payment method to continue. _link_",
  "errors.api.accounting.has_no_payment_method_owner_document_view": "Register a payment method to access all signature levels. _link_",
  "errors.api.accounting.has_unpaid_invoices_admin_member": "There are several outstanding invoices that need to be paid. For this reason, the account has been blocked. Please contact your administrator to reactivate the account.",
  "errors.api.accounting.has_unpaid_invoices_owner": "There are several outstanding invoices that need to be paid. For this reason, the account has been blocked. Please settle the outstanding invoices to reactivate the account. _link_",
  "errors.api.add_document_error": "The document cannot be signed",
  "errors.api.add_signee": "Error adding signee",
  "errors.api.autograph.file.invalid": "Your signature format is no longer supported. Please delete your current signature and upload a new one in JPEG, JPG, or PNG format.",
  "errors.api.autograph.file.too_big": "The resolution of the selected autograph image is too big. Maximal long side is 5000px. Maximal short side is 3500px.",
  "errors.api.autograph.file.too_big_file_size": "Maximum file size exceeded. A maximum of {size}MB are allowed.",
  "errors.api.autograph_position": "Error setting signature position",
  "errors.api.avScan.virusFound": "The file is infected by a virus",
  "errors.api.deep_id.api_not_reachable": "Unfortunately, an internal error has occurred. Please try again",
  "errors.api.deep_id.bearer_not_of_legal_age": "Unfortunately, due to age restrictions, you are not eligible to use Deep ID to digitally sign documents.\n  Please note that DeepID is only available to users who have reached the minimum age of 18.\n   We apologise for any inconvenience this may cause you.",
  "errors.api.deep_id.blocked_country": "Unfortunately, your nationality is not currently supported by DeepID.\n \n\nWe will notify you as soon as we have everything prepared and support your country.",
  "errors.api.deep_id.blocked_domicile": "Unfortunately, your domicile is not currently supported by DeepID. We will notify you as soon as we have everything prepared and support your country.",
  "errors.api.deep_id.blocked_nationality": "Unfortunately, your nationality is not currently supported by DeepID.   We will notify you as soon as we have everything prepared and support your country.",
  "errors.api.deep_id.document_expired": "Unfortunately, your ID document that you have registered in DeepID has expired. Please open your DeepID app and register a new identification document (passport or ID card) that authorises you to digitally sign.",
  "errors.api.deep_id.document_invalidated": "Unfortunately, you have not registered a valid ID document in DeepID that authorises you to sign documents digitally. The documents you have entered have been marked as invalid. Please open your DeepID app and register a new ID document (passport or identity card) that authorises you to sign digitally.",
  "errors.api.deep_id.document_type": "Unfortunately, you have not registered a valid ID document in DeepID that authorises you to sign documents digitally. The documents you have registered can unfortunately not be used for digital signing. Please open your DeepID app and register a new ID document (passport or identity card) that authorises you to sign digitally.",
  "errors.api.deep_id.error.sign.document.concurrent.modification": "Document changed while signing, because someone else signed in parallel. Please try again.",
  "errors.api.deep_id.error.sign.failed": "Something went wrong. Please try again later.",
  "errors.api.deep_id.error.sign.identity.not-ready": "DeepID identity not ready.",
  "errors.api.deep_id.error.unknown_error": "Unfortunately, an error has occurred. Please try again. If the problem persists, please contact {email}",
  "errors.api.deep_id.identification_stale": "After 5 years, you must re-register your documents so that they can be used again for digital signing of documents. Please open your DeepID app and renew your ID document (passport or identity card) that allows you to sign digitally.",
  "errors.api.deep_id.identity_proofing_process": "Unfortunately, you have not registered a valid ID document in DeepID that authorises you to sign documents digitally. The documents you have registered can unfortunately not be used for digital signing. Please open your DeepID app and register a new ID document (passport or identity card) that authorises you to sign digitally.",
  "errors.api.deep_id.internal_error": "Unfortunately, an internal error has occurred. Please try again",
  "errors.api.deep_id.unknown_error": "Unfortunately, an error has occurred. Please try again. If the problem consist, please contact {email}",
  "errors.api.deep_id.unsuitable_domicile": "Unfortunately, your domicile is not currently supported by DeepID. We will notify you as soon as we have everything prepared and support your country.",
  "errors.api.deep_id.visual_verification": "Unfortunately, your registered ID document has not been verified yet. Have a little patience and try again in a few minutes.",
  "errors.api.delete_document": "There was an error during document deletion.",
  "errors.api.document_not_found": "Document not available. The signature process might have been modified or terminated.",
  "errors.api.download_document": "Could not download the document.",
  "errors.api.error.attachment.file.tooBig": "The file is too big.",
  "errors.api.error.attachment.file.tooMany": "The maximum number of attachments is 50.",
  "errors.api.error.document.file.tooBig": "The file is too big.",
  "errors.api.error.pdf.certified.noChangeAllowed": "The file is certified, no changes allowed.",
  "errors.api.error.pdf.password.protected": "The file is password protected.",
  "errors.api.error.pdf.read.failed": "The PDF document could not be read.",
  "errors.api.error.pdf.signatureFieldLock.noChangeAllowed": "Document locked by a signature and can not longer be signed.",
  "errors.api.error.pdf.unsupported.encryption": "The PDF cannot be uploaded because it contains an unsupported encryption.",
  "errors.api.error.predefined.multiple.signature.fields": "The document contains multiple seal placeholders, which is currently not supported.",
  "errors.api.error.sign.document.invalid": "Document is invalid",
  "errors.api.error.sign.failed": "Sign failed",
  "errors.api.error.sign.identity.not-ready": "DeepID identity not ready.",
  "errors.api.error.sign.use.failed": "Use Failed",
  "errors.api.error.sign.user.cancel": "Signature canceled by the user",
  "errors.api.error.sign.user.expired": "Expired",
  "errors.api.error.sign.user.onboarding.incomplete": "Onboarding incomplete",
  "errors.api.error.sign.user.otp.invalid": "Invalid OTP code",
  "errors.api.error.sign.user.password.invalid": "Password invalid",
  "errors.api.error.sign.user.retired": "Retired",
  "errors.api.error.sign.user.serialNumber.mismatch": "A problem has been detected with your Mobile ID. Please visit our support page for more information.",
  "errors.api.error.sign.user.timeout": "Signature canceled, timeout",
  "errors.api.error.start.approver.email.empty": "The document has undefined approvers.",
  "errors.api.error.start.observer.email.duplicate": "The document has duplicate observers.",
  "errors.api.error.start.observer.email.empty": "The document has undefined observers.",
  "errors.api.error.start.signee.email.empty": "The document has undefined signees.",
  "errors.api.error.start.signees.empty": "The document has empty signees.",
  "errors.api.error.start.status.draft.required": "The document status is required to be draft.",
  "errors.api.error.subscription.failed": "Error signing document: The requestor does not have an active subscription. Please contact this person.",
  "errors.api.error.subscription.observer.unavailable": "Observers can only be used from the DeepBox subscription Small.",
  "errors.api.error.unknown_error": "Unfortunately, an error has occurred. Please try again. If the problem consist, please contact {email}",
  "errors.api.fetch_auth_sign_info": "Unable to view document",
  "errors.api.fetch_next_documents_error": "Error getting documents",
  "errors.api.mobile_id.error.sign.document.concurrent.modification": "Document changed while signing, because someone else signed in parallel. Please try again.",
  "errors.api.mobile_id.error.sign.failed": "Something went wrong. Please try again later.",
  "errors.api.mobile_id.error.sign.user.serialNumber.mismatch": "A problem has been detected with your Mobile ID. Please visit our support page for more information.",
  "errors.api.mobile_id.unknown_error": "Unfortunately, an error has occurred. Please try again. If the problem persists, please contact {email}",
  "errors.api.no_invitations_to_resend": "There are no invitations to resend",
  "errors.api.no_reminders_to_send": "There are no reminders to send",
  "errors.api.no_subscription_found": "No subscription found.",
  "errors.api.reject_signature": "The signature could not be rejected",
  "errors.api.remove_signee": "Error removing signee",
  "errors.api.send_email": "Error sending E-Mail",
  "errors.api.send_reminder": "The reminder could not be sent",
  "errors.api.sign_document": "Error signing document",
  "errors.api.signature_process_approved": "The signature process was approved correctly",
  "errors.api.signature_process_approved_error": "Something went wrong while approving the signature process",
  "errors.api.signature_process_reject_error": "Something went wrong while rejecting the signature process",
  "errors.api.start_document_error": "The signature process cannot be started",
  "errors.api.subscription_signature_authorization_failed": "Could not authorize new signatures, please check your subscription.",
  "errors.api.update_document": "Error updating document.",
  "errors.api.update_signee": "Error updating signee",
  "errors.api.user_mismatch": "The current user ({userEmail}) does not correspond to the invited signee. Please login with the correct user in order to proceed.",
  "errors.api.validate_signatures": "The signatures on this document could not be validated.",
  "errors.api.validate_signatures_file_too_large": "This document is too large to be validated. A maximum of {size} MB is allowed.",
  "errors.api.validate_signatures_unsupported_document": "This document cannot be validated by DeepValidator.",
  "errors.api.withdraw_document": "The document could not be withdrawn.",
  "errors.code": "Code",
  "errors.custom.identification_status": "There was a error while checking your identification status.",
  "errors.document_not_found": "Document not found",
  "errors.duplicate": "{name}  duplicated",
  "errors.email": "Email field must be a valid email.",
  "errors.envelope_file_limit_reached": "An envelope can contain at most {max} documents.",
  "errors.envelope_file_no_visual_signature": "No visual signature has yet been placed for at least one signer.",
  "errors.envelope_file_unsupported_type": "Only PDF, Word and Excel files can be added.",
  "errors.envelope_max_size_exceeded": "The maximum envelope size of {max} MB would be exceeded. The file was not added.",
  "errors.error_occurred": "An error occurred",
  "errors.generic": "It looks like there was an error! Please try again later.",
  "errors.generic_title": "Oops it looks like there was an error!",
  "errors.home": "Home",
  "errors.invalid": "{name} field is invalid",
  "errors.invalid_mobile_number": "This is not a valid mobile number",
  "errors.invalid_phone_number": "Phone number is invalid",
  "errors.invalid_swiss_mobile_phone_number": "Only Swiss mobile numbers are supported (prefixes starting with 075, 076, 077, 078, or 079).",
  "errors.logged_out": "You have been logged out",
  "errors.login": "Back to login",
  "errors.max": "The field cannot contain more than {length} characters",
  "errors.maximum_file_size": "The total size of all documents may not exceed 40 MB. Remove files to be able to sign.",
  "errors.multiple_files_forbidden": "Please upload only one file.",
  "errors.no_comma": "The field cannot contain \",\"",
  "errors.no_visual_signature_placed": "No visual signature has been placed",
  "errors.not_found": "Not found",
  "errors.observer_duplicate": "Observer with this email does already exist.",
  "errors.page_not_found": "Page not found",
  "errors.remove_approver_error": "An error occurred while removing the approver, please try again later.",
  "errors.remove_signee_error": "An error occurred while removing the signee, please try again later.",
  "errors.required": "{name} field is required",
  "errors.unsupported_document_format": "The uploaded file format is not supported. Only PDF files are supported.",
  "errors.unsupported_file_format": "The uploaded file format is not supported. Only JPG and PNG files are supported.",
  "errors.virus_infected_files": "{number} file infected by a virus | {number} files infected by a virus",
  "footer.gtc": "GTC",
  "footer.help": "Help",
  "footer.link.help": "Help",
  "footer.link.impressum": "Impressum",
  "footer.link.privacy_policy": "Privacy Policy",
  "footer.link.terms_of_service": "Terms of Service",
  "footer.privacy_policy": "Privacy policy",
  "header.titles.created_date": "Creation date",
  "header.titles.document_name": "Document name",
  "header.titles.filesize": "File size",
  "header.titles.status": "Status",
  "hints.restart_verification_hint": "Please only restart the verification if the code is shown as no longer valid in the DeepID app.",
  "hints.scan_qr_code": "Scan the QR code with the smartphone camera",
  "info.required_signature": "This document requires a visual signature first to be signed.",
  "labels.add_group_members": "Add group members",
  "labels.add_message": "Add message",
  "labels.admin": "Admin",
  "labels.advanced_plus_option": "Advanced+ option",
  "labels.all": "All",
  "labels.allow_attachments": "Allow attachments for signee",
  "labels.approver_email": "E-mail Approver",
  "labels.autocomplete_no_data": "No data available",
  "labels.country": "Country",
  "labels.current_user": "Current user",
  "labels.display_name": "Display name",
  "labels.document": "Document",
  "labels.electronic_records": "electronic records",
  "labels.email": "E-mail",
  "labels.enable_envelope": "Send as Envelope",
  "labels.enforce_authority_service": "Enforce authority service",
  "labels.envelope_name": "Envelope name",
  "labels.firstname": "First name",
  "labels.group_members_will_be_added": "The individuals will be added as signatories",
  "labels.group_quorum_control": "Group signing",
  "labels.group_slot_position": "Group {group} - Slot {slot} of {total}",
  "labels.groups": "Groups",
  "labels.id_service": "ID Service",
  "labels.invited_user": "Invited user",
  "labels.knowledge_base": "knowledge base",
  "labels.lastname": "Last name",
  "labels.members": "Members",
  "labels.message": "Message",
  "labels.next_signature_position": "Next signature position",
  "labels.no_groups_found": "No groups were found",
  "labels.no_members_found": "No members found",
  "labels.of": "of",
  "labels.organizations": "Organizations",
  "labels.page": "page",
  "labels.personal": "Personal",
  "labels.phone_number": "Phone number",
  "labels.place_signature_on_document": "Place signature on document",
  "labels.place_signatures_on_document": "Place all signatures on the document",
  "labels.previous_signature_position": "Previous signature position",
  "labels.reject_signature": "Describe the reason for rejecting the signature.",
  "labels.signature_discloser": "signature disclosure",
  "labels.signature_position_on_page": "Signature {number} · Page {page}",
  "labels.signature_tag_aes": "AES",
  "labels.signature_tag_qes": "QES",
  "labels.signature_tag_ses": "SES",
  "labels.signee_email": "E-mail Signatory",
  "labels.slot_number": "Slot {number}",
  "labels.summarize": "Summarize",
  "labels.summarized_document_content": "Summarized document content",
  "labels.undefined_observer": "Undefined observer",
  "labels.user": "User",
  "labels.view_placed_signatures_on_document": "View placed signatures on document",
  "links.envelope_learn_more": "https://support.deepcloud.swiss/en/article/deepsign-envelope-feature/",
  "links.qes_deepid_failed": "https://support.deepcloud.swiss/en/article/qes-or-aes-not-possible-with-deepid/",
  "links.qes_mobileid_failed": "https://support.deepcloud.swiss/en/article/signature-with-mobile-id-not-possible/",
  "links.support_page": "https://support.deepcloud.swiss/en/article/signature-with-mobile-id-not-possible/",
  "paginations.pages_with_total": "1 page | {currentPage} of {n} pages",
  "placeholders.add_message": "Add your message",
  "placeholders.add_message_for_requestor": "Add message for requestor",
  "placeholders.add_message_for_signees": "Add message for signees",
  "placeholders.link": "Please enter the url of the link",
  "placeholders.phone_number": "Enter a phone number",
  "placeholders.reject_signature": "Describe the reason for rejecting the signature.",
  "placeholders.reject_signature_process": "Describe the reason for the rejection.",
  "placeholders.withdraw": "Describe the reason for withdrawing.",
  "seo.description": "Sign your documents online from anywhere. DeepSign is flexible, secure and legally valid in EU and Switzerland.",
  "service_worker.btn_reload_later": "Reload later",
  "service_worker.btn_reload_now": "Reload now",
  "service_worker.text_reload_recommended": "A new version of DeepSign is available. It is recommended to reload now to activate the new version.",
  "settings.buttons.add_new_user": "Add new user",
  "settings.buttons.back": "Back",
  "settings.buttons.create_seal": "Create Seal",
  "settings.buttons.save": "Save",
  "settings.errors.duplicate_seal_key": "There is already a seal with this Seal Key.",
  "settings.errors.error_fetching_certificate_seals": "There was an error getting this organization's seals",
  "settings.errors.error_fetching_certificates": "There was an error fetching your company's certificates. Please try again later.",
  "settings.errors.preview_cannot_be_loaded": "Signature preview cannot be loaded",
  "settings.headers.actions": "Actions",
  "settings.headers.can_manage_accesses": "Can manage accesses",
  "settings.headers.email": "Email",
  "settings.headers.name": "Name",
  "settings.headers.seal_description": "Description",
  "settings.headers.seal_display_name": "Display name",
  "settings.headers.seal_key": "Seal key",
  "settings.headers.seal_type": "Seal type",
  "settings.here": "here",
  "settings.input_help.seal_key": "Pattern: 1-50 characters, lowercase letters, numbers, or hyphens",
  "settings.labels.description": "Description",
  "settings.labels.display_name": "Display name",
  "settings.labels.email": "Email",
  "settings.labels.localtion": "Location",
  "settings.labels.optional_text": "Additional Text",
  "settings.labels.organization_signature_preview": "Preview the visual signature of your organisation",
  "settings.labels.seal_key": "Seal key",
  "settings.labels.seal_logo": "Seal logo",
  "settings.labels.signature_preview": "Preview your visual signature",
  "settings.labels.user_can_manage_accesses": "User is able to manage accesses to this seal",
  "settings.menu_headers.account": "User account",
  "settings.menu_headers.organization": "Organisation account",
  "settings.navigation.company_seals": "Seals",
  "settings.navigation.company_signature": "Signature appearance",
  "settings.navigation.my_signature": "My signature",
  "settings.organization_signature.date": "Date",
  "settings.organization_signature.date_hint": "Date when signing takes place",
  "settings.organization_signature.date_off_location_hint": "Date must be active in order to enable location",
  "settings.organization_signature.deepSignLogo": "DeepSign Logo",
  "settings.organization_signature.deepSignLogo_hint": "Setting applies to all signatories",
  "settings.organization_signature.location": "Location",
  "settings.organization_signature.location_hint": "Only displayed if defined by the signatory",
  "settings.organization_signature.name": "Name",
  "settings.organization_signature.name_hint": "Name of the signee",
  "settings.organization_signature.optionalText": "Additional text",
  "settings.organization_signature.optionalText_hint": "Only displayed if defined by the signatory",
  "settings.organization_signature.signatureType": "Level of Security",
  "settings.organization_signature.signatureType_hint": "Setting applies to all signatories",
  "settings.placeholders.description": "Enter some description",
  "settings.placeholders.display_name": "Enter the display name of the seal",
  "settings.placeholders.email": "Enter your email",
  "settings.placeholders.location": "Define displayed location",
  "settings.placeholders.optional_text": "Define text (e.g. function)",
  "settings.placeholders.unique_seal_key": "Enter a unique seal key",
  "settings.snackbar.add_admin_error": "There was an error adding the user",
  "settings.snackbar.add_admin_success": "The user was added successfully.",
  "settings.snackbar.create_seal_error": "There was an error creating this seal.",
  "settings.snackbar.create_seal_success": "Seal successfully created.",
  "settings.snackbar.delete_seal_error": "There was an error deleting this seal",
  "settings.snackbar.delete_seal_success": "Seal deleted successfully",
  "settings.snackbar.save_user_signature_error": "There has been an error updating your signature data.",
  "settings.snackbar.save_user_signature_success": "Your data has been saved correctly.",
  "settings.snackbar.update_company_signature_error": "There has been an error updating the company signature.",
  "settings.snackbar.update_company_signature_success": "Company signature successfully updated.",
  "settings.snackbar.user_remove_error": "There was an error removing the user",
  "settings.snackbar.user_remove_success": "User successfully removed",
  "settings.subscriptions.small": "Small",
  "settings.subtitles.company_has_no_valid_subscription": "Starting from the {small} plan, you can customise the appearance of the visual signature within your organisation. Upgrade your plan {here}.",
  "settings.subtitles.company_signature": "This template applies to all signatures executed by the organization and ensures a consistent and standardized appearance for all documents.",
  "settings.subtitles.my_signature": "The display may differ when signing due to the configuration of your organisation. When signing a document, you will see a preview of the signature used.",
  "settings.subtitles.seals": "Seals",
  "settings.tabs.seal": "Seal",
  "settings.tabs.user_management": "Users management",
  "settings.texts.delete_seal_admin_message": "This user wont be able to access this seal anymore",
  "settings.texts.delete_seal_message": "This will delete seal \"{sealName}\"",
  "settings.texts.no_certificates": "The selected company has no certificates yet.",
  "settings.titles.add_new_user_to seal": "Add a new user to this seal",
  "settings.titles.certificate_details": "Certificate details",
  "settings.titles.company_certificates": "Company Certificates",
  "settings.titles.company_seal_details": "Seal details",
  "settings.titles.company_signature": "Organization Signature Template",
  "settings.titles.create_seal": "Create seal",
  "settings.titles.my_signature": "My signature",
  "settings.validation.location": "The location may be a maximum of 100 characters long",
  "settings.validation.optional_text": "The additional text may be a maximum of 100 characters long",
  "settings.validation.seal_key": "Seal Key must be 1-50 characters and contain only lowercase letters, numbers, or hyphens.",
  "settings.warnings.insufficient_permissions": "Sorry, you do not have the necessary permissions to access this page.",
  "slugs.signature_levels": "/en/topic/deepsign/first-steps-deepsign-en/",
  "snackbars.approver_removed": "Approver successfully removed",
  "snackbars.attachments_not_added": "{count} file(s) could not be added. The maximum number of attachments is {max}.",
  "snackbars.batch_documents_signed": "{number} documents signed successfully.",
  "snackbars.document_deleted": "{number} Documents successfully deleted from DeepSign",
  "snackbars.document_rejected_by_approver": "The document has been rejected",
  "snackbars.document_rejected_by_approver_envelope": "The documents have been rejected",
  "snackbars.document_sealed": "Document is fully sealed",
  "snackbars.document_signed": "Document is fully signed",
  "snackbars.document_signed_envelope": "All {n} Documents are fully signed",
  "snackbars.document_withdrawn": "Document has been withdrawn.",
  "snackbars.document_withdrawn_envelope": "The documents have been withdrawn.",
  "snackbars.document_withdrawn_multiple": "{number} documents have been withdrawn.",
  "snackbars.documents_created": "{number} Files successfully uploaded as Draft",
  "snackbars.email_sent": "E-Mail was successfully sent",
  "snackbars.envelope_files_not_added": "{count} file(s) could not be added to the envelope.",
  "snackbars.error_sent_invitations": "Document could not be sent because mandatory settings are missing. Detail: ",
  "snackbars.error_sent_invitations_generic": "Something went wrong sending invitations",
  "snackbars.feedback_error": "There was an error sending your comments, please try again later.",
  "snackbars.file_add_failed": "\"{name}\" could not be added to the envelope.",
  "snackbars.file_added": "Document added to the envelope.",
  "snackbars.file_delete_failed": "The document could not be removed from the envelope.",
  "snackbars.file_deleted": "Document removed from the envelope.",
  "snackbars.file_order_update_failed": "The document order could not be updated.",
  "snackbars.learn_more": "Learn more",
  "snackbars.manage": "Manage",
  "snackbars.manage_subscription": "Manage subscription.",
  "snackbars.not_signed_text": "The document has not been signed",
  "snackbars.observer_added": "Observer successfully added",
  "snackbars.observer_removed": "Observer successfully removed",
  "snackbars.sealed_text": "Your document was successfully sealed.",
  "snackbars.seals.documents_created": "{number} Files successfully uploaded.",
  "snackbars.signature_forwarded": "Signature successfully forwarded",
  "snackbars.signature_process_approved": "You have successfully approved the document",
  "snackbars.signature_process_approved_envelope": "The documents were successfully approved.",
  "snackbars.signature_process_approved_error": "Something went wrong while approving the signature process",
  "snackbars.signature_rejected": "The signature has been rejected",
  "snackbars.signature_rejected_by_approver": "Signature no longer possible due to rejection by an Approver",
  "snackbars.signature_rejected_by_signee": "The signature was declined by one of the signatories.",
  "snackbars.signature_updated_error": "There was an error updating the signature",
  "snackbars.signature_updated_success": "The signature was updated correctly",
  "snackbars.signed_text": "You have successfully signed the document.",
  "snackbars.signed_text_envelope": "You have successfully signed {n} documents.",
  "snackbars.signee_added": "Signee successfully added",
  "snackbars.signee_removed": "Signee successfully removed",
  "snackbars.successfully_sent_invitation": "Document sent successfully.",
  "snackbars.successfully_sent_invitations": "{number} files have been sent successfully.",
  "snackbars.support_requested": "Thank you for your support request. We will get back to you within the next 24 hours.",
  "subscriptions.ask_owners": "Please get in touch with the Owners of your organisation to change your subscription",
  "subscriptions.small": "Small",
  "terms.eidas": "Swisscom creates the requested signature on my behalf using my data. I accept the _link_ and confirm my residence in one of these _countries_.",
  "terms.guest_ses": "I agree to the _link_ of DeepCloud AG. I have taken note of the _privacy_",
  "terms.zertes": "Swisscom creates the requested signature on my behalf using my data. I accept the _link_ and confirm my residence in one of these _countries_.",
  "text.archive.allowed.empty": "Documents are deleted 14 days after the finalization of the signature process. Older documents can be found in the",
  "text.archive.allowed.not_empty": "Documents are deleted 14 days after the finalization of the signature process. Older documents can be found in the",
  "text.archive.not_allowed.empty": "No completed documents are available. Documents are deleted 14 days after the finalization of the signature process.",
  "text.archive.not_allowed.not_empty": "Documents will be deleted 14 days after the finalization of the signature process.",
  "text.countries": "supported countries",
  "text.deepsign_storage": "DeepSign Storage",
  "text.document": "{n} selected",
  "text.documents_total": "{n} Document | {n} Documents",
  "text.identity.deep_id_web.cancel_dialog.confirm": "Cancel",
  "text.identity.deep_id_web.cancel_dialog.continue": "Continue",
  "text.identity.deep_id_web.cancel_dialog.text": "Your progress in DeepID will be lost and you will have to start the identification again.",
  "text.identity.deep_id_web.cancel_dialog.title": "Cancel identification?",
  "text.identity.qr_code.restart_verification_dialog.text": "If you generate a new QR code, any ongoing identifications cannot be completed and must be restarted. Please create a new QR code only if the current code is no longer recognized as valid when scanned in the DeepID app.",
  "text.identity.qr_code.restart_verification_dialog.title": "Generate new QR code",
  "text.learn_more": "Learn more",
  "text.manage_account": "Manage account",
  "text.manage_subscription": "Manage subscription",
  "text.no_document": "No documents.",
  "text.no_documents_description": "Upload a new document or change the filter to see more documents.",
  "text.no_result_description": "Try a new search.",
  "text.no_results": "No results.",
  "text.nodocumentdescription": "Try a new search.",
  "text.noducuments": "No results",
  "text.powered_by": "Powered by",
  "text.privacy_policy": "Privacy Policy",
  "text.reject_signature_process_subtitle": "After you have rejected the approval, the applicant and the recipients can no longer sign. The signature process is terminated.",
  "text.seal_annotation_layer": "Enter additional text here (optional)",
  "text.seal_annotation_placeholder": "Additional Text",
  "text.selected_documents": "{n} Selected documents",
  "text.settings": "Settings",
  "text.signature_validation.powered_by": "Powered by",
  "text.terms_and_conditions": "Terms and conditions",
  "text.unpaid_invoice_link": "To the invoices",
  "text.website": "website",
  "text_unselect_all": "Unselect all",
  "texts.account_mismatch_no_account": "This invitation is not intended for the account you are currently logged in with. To continue, please per-form one of the following actions.",
  "texts.account_mismatch_text": "This invitation is not intended for the account you are currently logged in with. To continue, please perform one of the following actions.",
  "texts.account_mismatch_text_single_option": "This invitation is not intended for the account you are currently logged in with. Please login with the invited email.",
  "texts.add_observer_text_hint": "An observer can follow the signature progress of a document without signing it.",
  "texts.add_signee_first": "Please add a signee first",
  "texts.advanced": "AES - With certificate and timestamp. Requires signatory identification and additional authentication. Can be used when there is no statutory form requirement. Does not replace a handwritten signature.",
  "texts.advanced_plus": "###Advanced+ description###",
  "texts.advanced_short": "Digital signature with basic identity verification",
  "texts.advanced_signature_instructions": "As soon as you click on \"Continue\", you will receive an SMS with a code that you must enter in a new window.",
  "texts.allow_attachments_disabled_hint": "Attachments can only be used if only one person can initially sign the document. Thus, either only one person may sign or only one person may be in the first group when using signing orders.",
  "texts.allow_attachments_hint": "The invited person may upload additional documents as attachments before signing.",
  "texts.approver": "Approver",
  "texts.attachments_drag_drop": "Drag and drop",
  "texts.attachments_format_size_hint": "Supported format: PDF (up to {number}MB)",
  "texts.authentication_required": "Authentication required",
  "texts.available_on": "Available on",
  "texts.basic": "SES - The simplest signature, with a digital timestamp. Can be used if there is no statutory form requirement. Does not replace a handwritten signature and does not fulfil any legal form requirement.",
  "texts.basic_short": "Simplest form of signature with digital timestamp",
  "texts.cant_withdraw_policy": "{availableDocs} of {total} selected documents can be withdrawn. Only documents that allow this will be withdrawn.",
  "texts.check_identity_did_hint": "For qualified and advanced signatures, your identity must be verified. To do this, scan the QR code and follow the instructions in the DeepID app.",
  "texts.check_identity_did_hint_mobile": "For qualified and advanced signatures, your identity must be verified. Open our app DeepID and follow the instructions in the app.",
  "texts.check_identity_ras_hint": "For authentication via MobileID, a few more pieces of information are needed.",
  "texts.check_identity_ras_unsupported_region_hint": "The phone number you provided cannot be used, as only Swiss mobile numbers are supported. Please enter a new phone number.",
  "texts.check_identity_sign8_hint": "Follow the instructions on in the new browser window to verify your identity.",
  "texts.check_identity_sms_code_hint": "For authentication via SMS-Code, a few more pieces of information are needed.",
  "texts.choose_from": "Choose from",
  "texts.correctly_uploaded_file": "File uploaded correctly.",
  "texts.correlation_code": "Transaction ID",
  "texts.correlation_code_check": "Please compare this code with the request in {appName}.",
  "texts.customize_signature": "Customize signature",
  "texts.delete_attachment_confirmation": "Are you sure you want to remove \"{name}\"? This action cannot be undone.",
  "texts.delete_attachment_error": "Failed to remove attachment. Please try again.",
  "texts.delete_file_confirmation": "Are you sure you want to remove \"{name}\" from this envelope? This action cannot be undone.",
  "texts.disallow_signee_attachments_hint": "This option is unavailable when multiple documents are signed together in one process.",
  "texts.document_loading": "Document loading...",
  "texts.document_not_found": "Sorry, the document you are looking for doesn’t exist or has been withdrawn.",
  "texts.document_size_limit": "PDF, Word File (.docx) or Excel File (.xlsx) with a size of less than 40 MB",
  "texts.document_size_limit_upload": "PDF with a size of less than 40 MB",
  "texts.document_status": "Follow the progress and found the information about document status.",
  "texts.domain_signs": "{domain} emails sign",
  "texts.drag_drop_files": "Drop file here to start the signature process.",
  "texts.drag_drop_or": "Drag & drop documents here or",
  "texts.draw_your_signature": "Draw, {highlight}, or Drag and drop your signature",
  "texts.email_sent_to": "E-Mail was sent to {email}",
  "texts.email_signs": "{email} signs",
  "texts.empty_signee": "Signatory not defined",
  "texts.enforce_authority_service_description": "All signatories must identify themselves via the ID Service.",
  "texts.enforce_authority_service_hint": "All signers must use the defined ID-Service for signing, if activated. Otherwise the options DeepID and Mobile ID are available for all signers.",
  "texts.envelope_description": "Combine multiple documents into a single signing workflow.",
  "texts.envelope_file_limit_exceeded_hint": "{count} documents have been prepared for upload. However, a maximum of {max} documents is allowed per envelope. Please remove the excess documents in order to send them all in a single signature process.",
  "texts.envelope_max_size_hint": "The maximum size of an envelope is {max} MB.",
  "texts.file_too_large": "File too large.",
  "texts.file_too_large_short": "Only PDF, Word and Excel files up to 40Mb in size are supported.",
  "texts.forward_text_hint": "Hereby you transfer the signature rights to other persons. You still have access to the process, but you can no longer sign it yourself.",
  "texts.generic_upload_error": "There was an unexpected error while uploading.",
  "texts.get_started": "Organize the document for signing or request digital signatures.",
  "texts.i_am_signing": "I am signing",
  "texts.identification_by_deep_id": "Identification by {logo}",
  "texts.infobar.created_at": "Created at",
  "texts.infobar.details": "Details",
  "texts.infobar.initiator": "Initiator",
  "texts.infobar.jurisdiction": "Jurisdiction",
  "texts.infobar.no_selection": "Select an element to see the details",
  "texts.infobar.security_level": "Security level",
  "texts.infobar.selected_documents": "{count} Elements selected",
  "texts.information_by_email": "We will inform you by e-mail as soon as the document has been signed.",
  "texts.initiating_seal_done": "Document sealing done.",
  "texts.initiating_seal_in_progress": "Document sealing in progress.",
  "texts.invalid_key": "The provided key is expired or invalid. Please open the document from third party app again.",
  "texts.invitation_sent": "Invitation sent",
  "texts.invitations_sent_back_to_app": "Invitations have been sent. You can now return to the app.",
  "texts.invite_text_hint": "Invite another person to sign the document.",
  "texts.learn_more": "Learn more",
  "texts.mobile_id.serialNumber.mismatch": "Open Support Page",
  "texts.more_infomation": "More information",
  "texts.move_all_signatures": "Move all signatures...",
  "texts.move_one_seal": "Move seal to ...",
  "texts.move_one_signature": "Move signature to ...",
  "texts.must_login": "You must login to use this functionality.",
  "texts.no_attachments_hint": "This document has no attachments. You can not attach files after signing the document. \nAre you sure you want to sign it?",
  "texts.no_available_seals": "The selected organization has no seals, or you do not have the authorization to apply seals.",
  "texts.no_email_yet": "No email yet",
  "texts.no_items": "No items available.",
  "texts.no_payment_method_setup": "There is no payment method setup for this organisation, only your free SES signatures can be created.",
  "texts.no_results": "No results found",
  "texts.observers_dialog_hint": "An observer can follow the signature progress of a document without signing it. An observer with admin role has the same rights as the initiator and must belong to the initiator’s organisation.",
  "texts.on_hold_approval_hint": "You cannot sign at the moment as an approval is pending for this document. You will be notified when the document has been approved for signature.",
  "texts.on_hold_generic_hint": "You can't sign or approve this right now - it needs to follow the defined order first. We'll notify you when it's your turn.",
  "texts.on_hold_hint": "You cannot sign at the moment, this document requires the signature order to be respected.  You will be notified when the previous signatories have signed.",
  "texts.on_hold_hint_envelope": "You cannot sign at the moment, these documents require the signature order to be respected.  You will be notified when the previous signatories have signed.",
  "texts.open_deep_id": "Open the DeepID App and follow the instructions for a digital identification.",
  "texts.open_deepbox": "To initiate the process of digital signature of a document , all you have to do is go to DeepBox and right click on a document and “Sign with DeepSign”",
  "texts.participants_step_description": "Define participants",
  "texts.personal_space": "Personal DeepBox",
  "texts.place_before_signing": "Before you draw your signature, please place it in the correct position on the document.",
  "texts.place_signature": "Drag and drop it to the desired position in the document.",
  "texts.place_signature_touch_devices": "Click the button below and drag the signatures to the desired position.",
  "texts.place_signatures_hint": "Only manually added signatures will be affected, signatures linked to a predefined signature field will always remain visible and their position cannot be changed.",
  "texts.qualified": "QES - With certificate and timestamp. Requires signatory identification and additional authentication. Equivalent to a handwritten signature and complies with statutory form requirements in EU and Swiss law.",
  "texts.qualified_short": "Digital signature with verified identity. Legally equivalent to a handwritten signature.",
  "texts.qualified_signature_instructions": "Please confirm the signature in the {appName} app on your cell phone",
  "texts.qualified_signature_instructions_deep_id_web_confirm": "Confirm in Browser",
  "texts.qualified_signature_instructions_deep_id_web_confirm_external": "Confirm in Browser (ext)",
  "texts.qualified_signature_instructions_deep_id_web_hint": " or via {deepIdWeb} directly in the browser",
  "texts.qualified_signature_instructions_deep_id_web_hint_link": "DeepID Web",
  "texts.qualified_signature_instructions_deep_id_web_ident": "Use Web Ident",
  "texts.qualified_signature_instructions_deep_id_web_ident_external": "Use Web Ident (ext)",
  "texts.quorum_all_must_approve": "All ({count}) must approve",
  "texts.quorum_all_must_sign": "All ({count}) must sign",
  "texts.quorum_approvers_not_supported": "Quorum is not possible while approvers are invited.",
  "texts.quorum_hint": "Set how many persons must sign or approve. Example: Out of three persons, only two need to sign or approve.",
  "texts.quorum_hint_ungrouped": "Set how many of the persons are required to complete the signing.",
  "texts.quorum_invitees_need_to_approve": "{required} out of {total} persons need to approve",
  "texts.quorum_invitees_need_to_sign": "{required} out of {total} persons need to sign",
  "texts.quorum_invites_need_to_approve": "{required} out of {total} persons must approve",
  "texts.quorum_invites_need_to_sign": "{required} out of {total} persons must sign",
  "texts.quorum_mixed_group_not_supported": "Quorum for mixed groups is not possible.",
  "texts.quorum_need_to_approve": "{required} out of {total} persons must approve",
  "texts.quorum_need_to_sign": "{required} out of {total} persons must sign",
  "texts.quorum_of_count_must_approve": "of {total} persons must approve",
  "texts.quorum_of_count_must_sign": "of {total} persons must sign",
  "texts.quorum_summary": "Quorum {required}/{total}",
  "texts.reject_signature": "After you reject the signature, the requestor and the recipients cannot sign.",
  "texts.reject_signature_process": "Reject approval?",
  "texts.reminder_successfully_sent": "Reminder sent to {email}",
  "texts.reminders_successfully_sent": "Reminders sent successfully",
  "texts.remove_signatures_from_file_confirmation": "This will remove all the current signatures placed in this current file. Are you sure you want to proceed?",
  "texts.request_signatures": "Add e-mail addresses of people, which should sign the document.",
  "texts.saved_as_default": "Saved as default",
  "texts.seal_document_required": "You need to select one seal",
  "texts.seal_types_description.AES_CH": "Advanced Seal (ZertES)",
  "texts.seal_types_description.AES_EU": "Advanced Seal (eIDAS)",
  "texts.seal_types_description.GOV": "Regulated seal with authority certificate (ZertES)",
  "texts.seal_types_description.QES_CH": "Regulated Seal (ZertES)",
  "texts.seal_types_description.QES_EU": "Qualified Seal (eIDAS)",
  "texts.search_hint": "Try a new search term or reset the search.",
  "texts.select_organization": "Select organization",
  "texts.select_seal": "Select a seal",
  "texts.select_seal_placeholder": "Select a seal from the options below.",
  "texts.selected": "selected",
  "texts.send_reminder": "You will send a reminder to {email}",
  "texts.send_reminders": "You will send reminders to the following people:",
  "texts.sign_again": "Please try to sign the document again.",
  "texts.sign_document": "Sign the document online with secure digital signature.",
  "texts.sign_error_dialog_reference": "Error reference",
  "texts.signature_cancelled": "You have cancelled the signature. Please try again.",
  "texts.signature_level.AES": "Advanced Electronic Signature",
  "texts.signature_level.QES": "Qualified Electronic Signature",
  "texts.signature_level.SES": "Simple electronic signature",
  "texts.signature_mode_step_description": "Determine the evidentiary value",
  "texts.signature_validation.document_size_limit": "PDF with a size of less than 40 MB",
  "texts.signature_validation.drag_drop_files": "Drop file here to start the signature validation process.",
  "texts.signature_validation.drawer_search_combobox_maximum": "You reached the maximum",
  "texts.signature_validation.drawer_search_combobox_placeholder": "Enter any company name",
  "texts.signature_validation.drawer_search_combobox_required": "At least one company is required.",
  "texts.signature_validation.drawer_search_companies_title": "List of companies",
  "texts.signature_validation.drawer_upload_signature_button": "Upload new document",
  "texts.signature_validation.drawer_upload_signature_button_restart": "Restart verification",
  "texts.signature_validation.drawer_upload_signature_title": "Upload a new document to validate the signatures.",
  "texts.signature_validation.drawer_validation_companies": "Companies to verify",
  "texts.signature_validation.drawer_validation_not_signed": "Didn't sign",
  "texts.signature_validation.drawer_validation_not_trusted": "Not trusted",
  "texts.signature_validation.drawer_validation_other_signatures": "Other Signatures on the document:",
  "texts.signature_validation.drawer_validation_quorum": "Quorum reached",
  "texts.signature_validation.drawer_validation_quorum_not_reached": "Quorum not reached",
  "texts.signature_validation.drawer_validation_signed": "Signed",
  "texts.signature_validation.drawer_validation_trusted": "Trusted",
  "texts.signature_validation.error": "There has been an error verifying the signatures on this document.",
  "texts.signature_validation.tooltip_menu": "Only available for DeepID signed documents",
  "texts.signature_validation.verify_caption": "Here you will be able to verify if the signatures on this document are valid against different companies.",
  "texts.signatures_on_different_pages_warning": "All signatures will be moved to page {pageNumber}.",
  "texts.signatures_removed": "Signatures removed",
  "texts.signing_not_possible": "Signing not possible",
  "texts.step_of": "Step {current} of {total}",
  "texts.to_save_your_signature": "to save your signature",
  "texts.total_file_size": "Total files size",
  "texts.unavailable_modes": "Some options may be disabled for you due to your organization's settings.",
  "texts.unavailable_signature_mode": "This feature has been disabled for your organisation.",
  "texts.undefined_observers": "{number} undefined observer | {number} undefined observers",
  "texts.unsupported_attachment": "Only PDF files are supported, please remove this attachment.",
  "texts.unsupported_file": "File not supported.",
  "texts.unsupported_file_format": "File not supported.",
  "texts.unsupported_file_format_or_too_large": "Only {extensions} files up to {number} MB in size are supported. Please remove any documents not meeting these requirements before proceeding.",
  "texts.update_signee_email_hint": "A new invitation will be sent to the updated email.",
  "texts.update_signee_on_hold_email_hint": "An invitation will be sent to the updated email address as soon as it is the signatory's turn.",
  "texts.upload_file": "Upload",
  "texts.upload_your_signature": "Upload your signature",
  "texts.verification_badge_details.link": "https://support.deepcloud.swiss/en/article/verification-status/",
  "texts.verification_badge_details.unverified": "The identity of the sender was not verified by DeepCloud.",
  "texts.verification_badge_details.verified": "The identity of the sender was verified by DeepCloud.",
  "texts.visual_signatures_info": "Overview of the visual signatures placed on each document per signee.",
  "texts.want_to_continue": "Do you want to continue?",
  "texts.withdraw_document": "After you withdraw the invitation, the recipients will no longer be able to process the document.",
  "texts.withdraw_documents": "After you withdraw the invitation, the recipients will no longer be able to process the documents.",
  "texts.withdraw_signature": "After you withdraw your signature, the recipients will no longer be able to fully sign the document.",
  "texts.you": "You",
  "texts.you_seal_here": "You seal here",
  "texts.you_sign_here": "You sign here",
  "texts.your_seal": "Your seal",
  "title.approve_signature": "Approve signature",
  "title.edit_image": "Edit image",
  "titles.account_mismatch": "Account mismatch",
  "titles.add_message": "Add message",
  "titles.additional_settings": "Additional settings",
  "titles.advanced": "Advanced",
  "titles.advanced_plus": "Advanced+",
  "titles.advanced_signature": "Advanced signature",
  "titles.approval_rejected": "Approval rejected",
  "titles.approved_as": "Approved as",
  "titles.approver_rejected": "The approval was denied.",
  "titles.approvers": "Approvers",
  "titles.approving_as": "Approving as",
  "titles.attachments": "Attachments",
  "titles.attachments_title": "Attachments",
  "titles.authentication": "Authentication",
  "titles.basic": "Simple",
  "titles.basic_signature": "Simple signature",
  "titles.batch_start": "Send invitations",
  "titles.check_identity": "Check identity",
  "titles.check_your_inbox": "Check your inbox",
  "titles.comment": "Comment",
  "titles.define_order_of_signing": "Set order",
  "titles.delete_attachment": "Remove attachment",
  "titles.delete_document_dialog": "You are about to delete the document from DeepSign.",
  "titles.delete_file": "Remove document",
  "titles.document_not_found": "Document not found",
  "titles.document_status": "Document status",
  "titles.get_started": "Get Started",
  "titles.handwritten_signature": "Handwritten signature",
  "titles.initiating_seal": "Seal document",
  "titles.invitation_sent": "Invitations sent",
  "titles.invited_persons": "Invitees",
  "titles.invited_signatories": "Invited signatories",
  "titles.level_of_security": "Level of security",
  "titles.login": "Log in",
  "titles.message": "Message",
  "titles.message_to_all_participants": "Message to all participants",
  "titles.mobile_id_verification": "MobileID authentication",
  "titles.no_attachments": "Do you want to add attachments?",
  "titles.no_observers_subscription_dialog_ask_owners": "You have Observers defined. Observers can only be used from the DeepBox subscription Small. Please get in touch with the Owners of your organisation to change your subscription.",
  "titles.no_observers_subscription_title": "Missing subscription",
  "titles.observer_view": "Observer view",
  "titles.observers": "Observers",
  "titles.onboarding.get_started": "Get started",
  "titles.onboarding.guest.subtitle": "Please select how you want to continue.",
  "titles.onboarding.guest.title": "Review and sign document",
  "titles.open_deepbox": "Signing process needs to be started on DeepBox",
  "titles.participants_step": "Who signs",
  "titles.participants_step_participants": "Participants",
  "titles.place_signature": "Place signature",
  "titles.qualified": "Qualified",
  "titles.qualified_signature": "Qualified signature",
  "titles.ras_authentication_error": "Authentication error",
  "titles.reject_signature": "Reject signature?",
  "titles.reject_signature_process_text": "Message to the requestor and the already invited recipients (optional)",
  "titles.reject_signature_text": "Message to the requestor and the already invited recipients (optional)",
  "titles.request_signatures": "Request signatures",
  "titles.requestor": "Requestor",
  "titles.sealed_as": "Sealed as",
  "titles.sealing_as": "Sealing as",
  "titles.send_reminder": "Send reminder",
  "titles.set_link": "Set link",
  "titles.set_up_signing_workflow": "Set Up Signing Workflow",
  "titles.show_signature": "Show signature",
  "titles.sign_document": "Sign document",
  "titles.sign_error_dialog": "Error during sign process",
  "titles.sign_yourself": "I am signing",
  "titles.signature_cancelled": "Signature was cancelled",
  "titles.signature_confirmation": "Confirm signature",
  "titles.signature_mode_step": "Signature type",
  "titles.signature_mode_summary_card": "Signature mode",
  "titles.signature_rejected": "Signature rejected",
  "titles.signatures": "Signatures",
  "titles.signed_as": "Signed as",
  "titles.signee_rejected_signature": "Signature no longer possible due to rejection by a signee",
  "titles.signees": "Signatories",
  "titles.signees_messages": "Signees messages",
  "titles.signing_as": "Signing as",
  "titles.sms_code_verification": "SMS-Code authentication",
  "titles.successfully_verified": "Successful identification",
  "titles.summarize_file": "Summarize File",
  "titles.take_your_cell_phone": "Take your cell phone",
  "titles.take_your_phone": "Take your mobile phone",
  "titles.time_expired": "Time expired",
  "titles.to_be_signed": "To be signed",
  "titles.undefined_approver_confirmation_request": "You have at least one empty approver field. Do you want to clear all empty approver fields and continue with the sending of the invitations?",
  "titles.undefined_approvers": "Undefined approvers",
  "titles.undefined_approvers_and_observers": "Undefined approvers and observers",
  "titles.undefined_approvers_and_observers_confirmation_request": "You have empty approver and observer fields. Do you want to clear all empty fields and continue with the sending of the invitations?",
  "titles.undefined_approvers_and_signees": "Undefined approvers and signees",
  "titles.undefined_approvers_and_signees_and_observers_confirmation_request": "You have empty signature, approver and observer fields. Do you want to clear all empty fields and continue with the sending of the invitations?",
  "titles.undefined_approvers_and_signees_confirmation_request": "You have empty approver and signature fields. Do you want to clear all empty fields and continue with the sending of the invitations?",
  "titles.undefined_approvers_confirmation_request": "You have at least one empty approver field. Do you want to clear all empty approver fields and continue with the sending of the invitations?",
  "titles.undefined_approvers_signees_and_observers": "Undefined approvers,signees and observers",
  "titles.undefined_observers": "Undefined observers",
  "titles.undefined_observers_confirmation_request": "You have at least one empty observer field. Do you want to clear all empty observer fields and continue with the sending of the invitations?",
  "titles.undefined_signees": "Undefined signees",
  "titles.undefined_signees_and_observers": "Undefined signees and observers",
  "titles.undefined_signees_and_observers_confirmation_request": "You have empty signature and observer fields. Do you want to clear all empty fields and continue with the sending of the invitations?",
  "titles.undefined_signees_approvers_and_observers": "Undefined signees, approvers and observers",
  "titles.undefined_signees_approvers_and_observers_confirmation_request": "You have empty signature, approver and observer fields. Do you want to clear all empty fields and continue with the sending of the invitations?",
  "titles.undefined_signees_confirmation_request": "You have at least one empty signature field. Do you want to clear all empty signature fields and continue with the sending of the invitations?",
  "titles.upload_document": "Upload documents",
  "titles.visual_signatures": "Visual signatures",
  "titles.waiting_for_approval": "Waiting for approval",
  "titles.waiting_for_signature": "Waiting for signature",
  "titles.who_needs_to_sign": "Who signs",
  "titles.withdraw_document": "Withdraw the document?",
  "titles.withdraw_documents": "Withdraw the documents?",
  "titles.withdraw_message": "Message to the already invited recipients",
  "titles.withdraw_signature": "Withdraw your signature?",
  "titles.write_message_to_all_signatories": "Write message to all signatories",
  "tooltips.cannot_delete_file": "You can’t delete this document",
  "validation.document_not_found": "Document not found",
  "validation.duplicate": "{name}  duplicated",
  "validation.email": "Email field must be a valid email.",
  "validation.error_occurred": "An error occurred",
  "validation.generic_title": "Oops it looks like there was an error!",
  "validation.home": "Home",
  "validation.invalid": "{name} field is invalid",
  "validation.invalid_mobile_number": "This is not a valid mobile number",
  "validation.invalid_phone_number": "Phone number is invalid",
  "validation.logged_out": "You have been logged out",
  "validation.login": "Back to login",
  "validation.max": "The field cannot contain more than {length} characters",
  "validation.multiple_files_forbidden": "Please upload only one file.",
  "validation.no_comma": "The field cannot contain \",\"",
  "validation.not_found": "Not found",
  "validation.page_not_found": "Page not found",
  "validation.required": "{name} field is required",
  "validation.unsupported_document_format": "The uploaded file format is not supported. Only PDF files are supported.",
  "validation.unsupported_file_format": "The uploaded file format is not supported. Only JPG and PNG files are supported.",
  "view_options.grid": "Grid view",
  "view_options.layout": "Layout",
  "view_options.list": "List view"
}
